export const enum USER_ROLES {
    SUPER = 'super',
    GOD = 'god',
    USER = 'user',
    CREATOR = 'creator',
};

export const COOKIE_NAME = 'token';